/**
 * Quando a API se recusa a calcular — e por quê.
 *
 * Esta tela é um produto, não um erro. Metade das categorias de dejeto do
 * catálogo não tem análise medida, e o caminho fácil seria preencher com a
 * média de alguma coisa e devolver um número. O número sairia bonito e
 * estaria errado por um fator que ninguém conseguiria estimar depois.
 *
 * Então o app recusa, e a recusa carrega três coisas que uma mensagem de erro
 * comum não carrega: o que exatamente falta, em palavras de quem vai pedir a
 * análise ao laboratório; a categoria medida mais próxima, quando existe; e o
 * fato de que isso é lacuna de conhecimento do setor, não defeito do app.
 *
 * `analogo` não é um campo faltando: é a saída oferecida. Fica separado da
 * lista para não parecer mais uma análise a pagar.
 */
export function Recusa({ erro, onUsarAnalogo }) {
  if (!erro) return null;

  const faltando = erro.faltando ?? {};
  const analogo = faltando.analogo;
  const campos = Object.entries(faltando).filter(([k]) => k !== 'analogo');

  // A chave do análogo vem citada dentro da frase, entre aspas simples.
  const chaveDoAnalogo = analogo ? /'([^']+)'/.exec(analogo)?.[1] : null;

  return (
    <section className="cartao recusa" role="alert" aria-labelledby="titulo-recusa">
      <span className="selo selo--catalogo">Falta medir</span>

      <h2 id="titulo-recusa" className="recusa__titulo">
        {campos.length
          ? 'Ainda não dá para calcular isto com honestidade'
          : 'Não consegui calcular'}
      </h2>

      <p className="recusa__mensagem">{erro.message}</p>

      {campos.length ? (
        <>
          <h3 className="rotulo-secao">O que falta</h3>
          <ul className="recusa__lista">
            {campos.map(([campo, texto]) => (
              <li key={campo} className="recusa__item">
                {texto}
              </li>
            ))}
          </ul>
        </>
      ) : null}

      {analogo ? (
        <div className="recusa__saida">
          <p>{analogo}.</p>
          {chaveDoAnalogo && onUsarAnalogo ? (
            <button
              type="button"
              className="botao botao--secundario"
              onClick={() => onUsarAnalogo(chaveDoAnalogo)}
            >
              Estimar usando essa categoria
            </button>
          ) : null}
          <p className="terciario">
            O resultado sai como estimativa por semelhança, com a ressalva
            escrita no relatório. Não serve para financiamento — serve para
            saber se vale a pena mandar analisar.
          </p>
        </div>
      ) : null}
    </section>
  );
}
